import styled from "styled-components"
import axios from "axios"; //
import React, { useState, useEffect, useRef } from "react";
import { baseUrl } from "../config";
import { Table, ListContainer } from "./styles";
import { FaSortUp, FaSortDown } from "react-icons/fa";
import EventsList from "./EventsList";
import DetailDrawer from "./DetailDrawer";
import { DateIRLToErache } from "../utils/dateConverters";

const EVENTS_COLUMNS_STORAGE_KEY = "chronofield.columns.all-events";
const DEFAULT_EVENTS_COLUMN_VISIBILITY = {
  date: false,
  rpDescription: false,
  hrpDescription: false,
};

const loadEventColumnVisibility = () => {
  try {
    const raw = localStorage.getItem(EVENTS_COLUMNS_STORAGE_KEY);
    if (!raw) return DEFAULT_EVENTS_COLUMN_VISIBILITY;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return DEFAULT_EVENTS_COLUMN_VISIBILITY;
    }
    return { ...DEFAULT_EVENTS_COLUMN_VISIBILITY, ...parsed };
  } catch {
    return DEFAULT_EVENTS_COLUMN_VISIBILITY;
  }
};

const AllEventsList = () => {
  const [openDetail, setOpenDetail] = useState(null);
  const [events, setEvents] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "date",
    direction: "asc",
  });

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [columnFilters, setColumnFilters] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState(loadEventColumnVisibility);

  useEffect(() => {
    localStorage.setItem(EVENTS_COLUMNS_STORAGE_KEY, JSON.stringify(columnVisibility));
  }, [columnVisibility]);

  // Prevent out-of-order responses (page 1 finishing after page 2).
  const fetchSeqRef = useRef(0);
  const fetchEvents = async (pageIndex, pageSize, sortKey, sortDirection, columnFilters) => {
    const fetchSeq = ++fetchSeqRef.current;
    try {
      const params = {
        page: pageIndex + 1, // backend starts at 1
        pageSize,
        sortKey,
        sortDirection,
      };
      if (columnFilters) {
        columnFilters.forEach(filter => {
          params[filter.id] = filter.value;
        });
      }
      const response = await axios.get(baseUrl + "/events", {
        withCredentials: true,
        params: params
      });
      // Ignore stale responses.
      if (fetchSeq !== fetchSeqRef.current) return;
      setEvents(response.data.data);
      setRowCount(response.data.total);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchEvents(
      pagination.pageIndex,
      pagination.pageSize,
      sortConfig.key,
      sortConfig.direction,
      columnFilters

    );
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sortConfig.key,
    sortConfig.direction,
    columnFilters,
  ]);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const refetchEvents = () => {
    fetchEvents(pagination.pageIndex, pagination.pageSize, sortConfig.key, sortConfig.direction, columnFilters);
  };

  return (
    <AllEventsListContainer>
      <Title>Liste de tous les évènements</Title>
      <EventsList
        fetchEvents={fetchEvents}
        events={events}
        pagination={pagination}
        setPagination={setPagination}
        rowCount={rowCount}
        columnFilters={columnFilters}
        setColumnFilters={setColumnFilters}
        columnVisibility={columnVisibility}
        setColumnVisibility={setColumnVisibility}
        requestSort={requestSort}
        sortConfig={sortConfig}
        setSortConfig={setSortConfig}
        DateIRLToErache={DateIRLToErache}
        FaSortUp={FaSortUp}
        FaSortDown={FaSortDown}
        ListContainer={ListContainer}
        Table={Table}
        onOpenEventDetail={(id) => setOpenDetail({ type: "event", id })}
      />
      <DetailDrawer
        open={openDetail}
        onClose={() => setOpenDetail(null)}
        onOpenDetail={setOpenDetail}
        onEventDeleted={refetchEvents}
        DateIRLToErache={DateIRLToErache}
      />
    </AllEventsListContainer>
  );
};



export default AllEventsList;

const Title = styled.h1`
  margin-bottom: var(--space-4);
`;

const AllEventsListContainer = styled(ListContainer)`
  width: 100vw;
  max-width: 100vw;
  margin: 0 auto;
  overflow-x: auto;
  box-sizing: border-box;
  padding: 0 10px;
  padding-top: var(--space-10);
`;
